import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Grow } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {},
  frameWrapper: {
    height: `calc(100vh - ${62}px)`,
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  epub3: {
    // paddingTop: theme.spacing(1),
  },
  html5: {},
  iframe: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
  },
  scaledIframeContainer: {
    overflow: 'hidden',
    position: 'relative',
    margin: 'auto',
    flexShrink: 0,
  },
  scaledIframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: 0,
    border: 'none',
    transformOrigin: 'top left',
  },
}))

const ReaderFrame = React.forwardRef(
  (
    {
      variant = 'epub3',
      frameSrc = '',
      loaded = false,
      onLoad = () => {},
      contentWidth,
      contentHeight,
    },
    ref
  ) => {
    const classes = useStyles()
    const wrapperRef = useRef(null)
    const [scale, setScale] = useState(1)

    useEffect(() => {
      if (!contentWidth || !wrapperRef.current) return

      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          setScale(entry.contentRect.width / contentWidth)
        }
      })

      observer.observe(wrapperRef.current)
      return () => observer.disconnect()
    }, [contentWidth])

    return (
      <>
        {frameSrc ? (
          <div
            ref={wrapperRef}
            className={clsx(classes.frameWrapper, {
              [classes.epub3]: variant === 'epub3',
              [classes.html5]: variant === 'html5' || variant === 'digiiebook',
            })}
          >
            <Grow in={loaded}>
              {contentWidth && contentHeight ? (
                <div
                  className={classes.scaledIframeContainer}
                  style={{
                    width: contentWidth * scale,
                    height: contentHeight * scale,
                  }}
                >
                  <iframe
                    ref={ref}
                    id="iframe"
                    name="iframe"
                    loading="lazy"
                    title="Reader"
                    src={frameSrc}
                    onLoad={onLoad}
                    allowFullScreen
                    frameBorder="0"
                    className={classes.scaledIframe}
                    style={{
                      width: contentWidth,
                      height: contentHeight,
                      transform: `scale(${scale})`,
                    }}
                  />
                </div>
              ) : (
                <iframe
                  ref={ref}
                  id="iframe"
                  name="iframe"
                  loading="lazy"
                  title="Reader"
                  src={frameSrc}
                  onLoad={onLoad}
                  allowFullScreen
                  frameBorder="0"
                  className={clsx(classes.iframe)}
                />
              )}
            </Grow>
          </div>
        ) : null}
      </>
    )
  }
)

ReaderFrame.displayName = ReaderFrame

ReaderFrame.propTypes = {
  loaded: PropTypes.bool,
  frameSrc: PropTypes.string,
  onLoad: PropTypes.func,
  variant: PropTypes.string,
  contentWidth: PropTypes.number,
  contentHeight: PropTypes.number,
}

export default ReaderFrame
